import { createReducer } from "typesafe-actions";

import {
  hidePinLegendDrawer,
  PinSettingsUiActions,
  showCreatePinLegendDrawer,
  showPinSettings,
  showUpdatePinLegendDrawer,
} from "./actions";
import PinSettingsUiState from "./PinSettingsUiState";

export const pinSettingsUiInitialState: PinSettingsUiState = {};

const pinSettingsUi = createReducer<PinSettingsUiState, PinSettingsUiActions>(
  pinSettingsUiInitialState
)
  .handleAction(showCreatePinLegendDrawer, (state, { payload }) => ({
    ...state,
    entityType: payload.entityType,
    pinLegend: undefined,
    type: payload.type,
  }))
  .handleAction(showUpdatePinLegendDrawer, (state, { payload }) => ({
    ...state,
    entityType: payload.entity,
    pinLegend: payload,
    type: payload.type,
  }))
  .handleAction(showPinSettings, (state, { payload }) => ({
    ...state,
    pinLegendSettingsVisibility: payload,
  }))
  .handleAction(hidePinLegendDrawer, (state) => ({
    ...state,
    entityType: undefined,
    pinLegend: undefined,
    type: undefined,
  }));

export default pinSettingsUi;
